import useAuth from '@/composables/auth/useAuth'

export default {
  install: (): void => {
    useAuth().validateToken()
  }
}
